<template>
  <div v-if="!calendarBooked">
    <div class="row">
      <div class="col-lg-6 col-12 order-2 order-md-1 hot-site-testimonials">
        <img
          class="hot-site-testimonials-image"
          :src="require('@/assets/images/logoColored.png')"
          alt="header logo image"
        />
        <div
          v-for="(fields, i) in getHotSite?.fields?.testimonials?.content"
          :key="i"
          :class="`hs-${fields.nodeType}
          `"
        >
          <div v-if="fields.nodeType === 'unordered-list'">
            <div
              class="hot-site-testimonials-wrapper-top mt-0"
              v-for="(slide, i) in fields?.content"
              :class="i === activeTestimonial ? '' : 'hidden'"
              :key="i"
            >
              <div class="hot-site-testimonials-wrapper">
                <div class="row">
                  <div class="col-lg-2 col-12">
                    <i
                      class="mdi mdi-format-quote-open hot-site-testimonials-quotes"
                    ></i>
                  </div>
                  <div class="col-lg-10 col-12">
                    <div class="hot-site-testimonials-text">
                      {{ listBullet(slide).text }}
                    </div>
                    <div class="d-flex align-center">
                      <img
                        :src="images[i]"
                        class="partner-individuals-logos"
                        :alt="
                          imagesPlaceholder[i]
                            ? 'template body image'
                            : getImageURL(listBullet(slide).image, i)
                        "
                      />
                      <div class="ml-3">
                        <div class="partner-individuals-inner-name">
                          {{ listBullet(slide).title }}
                        </div>
                        <div class="hot-site-testimonials-title">
                          {{ listBullet(slide).name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="hot-site-testimonials-nav-bar">
              <div class="hot-site-testimonials-loader">
                <div
                  class="hot-site-testimonials-dot"
                  :class="i === activeTestimonial ? 'active' : ''"
                  v-for="(slide, i) in fields?.content"
                  :key="i"
                ></div>
              </div>
              <div class="hot-site-testimonials-navigation">
                <div
                  class="swiper-button-prev hot-site-testimonials-swiper"
                  @click="changeTestimonial('prev', fields?.content)"
                >
                  <i class="mdi mdi-arrow-left"></i>
                </div>
                <div
                  class="swiper-button-next hot-site-testimonials-swiper"
                  @click="changeTestimonial('next', fields?.content)"
                >
                  <i class="mdi mdi-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="fields.nodeType === 'blockquote'"
            class="hot-site-testimonials-badges"
          >
            <div
              v-for="(content, x) in fields.content"
              :key="x"
              class="hot-site-testimonials-badge"
            >
              {{ content?.content[0]?.value }}
            </div>
          </div>
          <div v-else>
            <div
              :class="
                fields.nodeType === 'paragraph'
                  ? 'learning-hub-paragraph'
                  : fields.nodeType === 'heading-3'
                  ? 'content-item hot-site-testimonials-main-title'
                  : fields.nodeType === 'heading-2'
                  ? 'learning-hub-large-right-title'
                  : fields.nodeType === 'heading-1'
                  ? 'learning-hub-tag'
                  : 'content-item article-body-right-small-title'
              "
            >
              <span v-for="(content, x) in fields.content" :key="x">
                <span
                  v-if="content?.nodeType === 'hyperlink'"
                  @click="openLink(content?.data?.uri)"
                  class="hyper-link"
                >
                  {{ content.content[0]?.value }}
                </span>
                <span v-else>{{ content?.value }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6 col-12 order-1 order-md-2 hot-site-questions-wrapper"
      >
        <div
          v-for="(fields, i) in getHotSite?.fields?.questions?.content"
          :key="i"
          class="w-100"
        >
          <div
            v-if="fields.nodeType === 'unordered-list'"
            :class="getQuestionCount(fields?.content)"
          >
            <div>
              <div class="hot-site-progress-label">
                {{ activeQuestion }} out of {{ questionCount }}
              </div>
              <div class="hot-site-progress-indicator-wrapper">
                <div
                  class="hot-site-progress-indicator"
                  :style="{ width: `${getProgress}%` }"
                ></div>
                <div
                  class="progress-indicator-right"
                  :style="{ width: `${100 - getProgress}%` }"
                ></div>
              </div>
            </div>
            <swiper
              ref="swiperRef"
              :slides-per-view="1"
              :space-between="0"
              :loop="false"
              :speed="500"
              :navigation="{
                nextEl: '.hot-site-button-next',
                prevEl: '.hot-site-button-prev',
              }"
              @swiper="onSwiper"
              @slideChange="onSlideChange"
            >
              <swiper-slide
                v-for="(list, n) in allFields(fields?.content)"
                :key="n"
              >
                <div v-for="(listItem, x) in list?.content" :key="x">
                  <div
                    v-if="listItem?.nodeType === 'paragraph'"
                    class="hot-site-questions-title"
                    :class="setParsedQuestions(listItem, n)"
                  >
                    {{ n + 1 }}. {{ listItem?.content[0]?.value }}
                  </div>
                  <div v-else-if="listItem?.nodeType === 'unordered-list'">
                    <v-radio-group v-model="answers[n]" color="#E05025">
                      <v-radio
                        v-for="(options, a) in parsedQuestions(listItem)
                          ?.options"
                        :key="a"
                        :label="options?.item"
                        :value="a"
                        class="hot-site-question-options"
                        :class="answers[n] === a ? 'active' : ''"
                        @click="answerQuestion(n, options)"
                      />
                    </v-radio-group>
                  </div>
                  <div v-else-if="listItem?.nodeType === 'calendar'">
                    <div
                      class="calendly-inline-widget hot-site-calendly"
                      :data-url="`https://calendly.com/comligo/45min?background_color=ffffff&text_color=111118&primary_color=e05025&hide_gdpr_banner=1${calendlyParams()}`"
                      :style="{
                        height:
                          activeQuestion === questionCount ? width : '0vw',
                        zoom,
                      }"
                    >
                      <div
                        v-if="calendarLoaded"
                        class="hot-site-placeholder-wrapper"
                      >
                        Almost there—your calendar is loading!
                      </div>
                    </div>
                    <div class="hot-site-disclaimer">
                      By entering your email address and clicking "Continue",
                      you confirm that you are at least 18 years old and agree
                      to our Terms and Conditions. For further details on your
                      data rights and how we process your information, please
                      see our
                      <span
                        class="disclaimer-link"
                        @click="$router.push('/privacy-policy')"
                        >Privacy Policy</span
                      >
                      and
                      <span
                        class="disclaimer-link"
                        @click="$router.push('/terms-and-conditions')"
                        >Terms & Conditions</span
                      >
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div
              class="hot-site-buttons"
              v-if="activeQuestion !== questionCount"
            >
              <md-outlined-button
                class="hot-site-button-prev"
                :style="{ display: activeQuestion > 1 ? 'block' : 'none' }"
              >
                Back
              </md-outlined-button>
              <md-filled-tonal-button
                class="hot-site-button-next"
                style="display: none"
              >
                Next
              </md-filled-tonal-button>
            </div>
          </div>
          <div
            v-else
            :class="
              fields.nodeType === 'paragraph'
                ? 'learning-hub-paragraph'
                : fields.nodeType === 'heading-3'
                ? 'content-item hot-site-questions-main-title'
                : fields.nodeType === 'heading-2'
                ? 'learning-hub-large-right-title'
                : fields.nodeType === 'heading-1'
                ? 'learning-hub-tag'
                : 'content-item article-body-right-small-title'
            "
          >
            <span v-for="(content, x) in fields.content" :key="x">
              <span
                v-if="content?.nodeType === 'hyperlink'"
                @click="openLink(content?.data?.uri)"
                class="questions-hyper-link"
              >
                {{ content.content[0]?.value }}
              </span>
              <span v-else>{{ content?.value }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row hot-site-bottom-section">
      <div class="col-lg-6 col-12">
        <div
          v-for="(fields, i) in getHotSite?.fields?.levels?.content"
          :key="i"
        >
          <div>
            <div v-if="fields.nodeType === 'unordered-list'">
              <v-tabs v-model="tab">
                <div></div>
                <v-tab
                  class="hot-site-level-tabs"
                  :value="i"
                  v-for="(item, i) in transformRichTextToTabs(fields)"
                  :key="i"
                  >{{ item?.tab }}</v-tab
                >
              </v-tabs>
              <v-window v-model="tab">
                <v-window-item
                  :value="i"
                  v-for="(item, i) in transformRichTextToTabs(fields)"
                  :key="i"
                  class="hot-site-level-window"
                >
                  <div
                    class="hot-site-level-window-items row"
                    v-for="(window, w) in item?.window"
                    :key="w"
                  >
                    <div class="col-1 hot-site-level-window-items-icon">
                      <i
                        class="mdi mdi-check-circle our-solutions-check m-0"
                      ></i>
                    </div>
                    <div class="col-11">{{ window }}</div>
                  </div>
                </v-window-item>
              </v-window>
            </div>
            <div
              v-else
              :class="
                fields.nodeType === 'paragraph'
                  ? 'learning-hub-paragraph'
                  : fields.nodeType === 'heading-3'
                  ? 'content-item hot-site-levels-main-title'
                  : fields.nodeType === 'heading-2'
                  ? 'learning-hub-large-right-title'
                  : fields.nodeType === 'heading-6'
                  ? 'hot-site-tag'
                  : 'content-item article-body-right-small-title'
              "
            >
              <md-filled-tonal-button
                class="learning-hub-outer-download-button"
                v-if="parseDownloadButton(fields?.content)"
              >
                <span v-for="(content, x) in fields.content" :key="x">
                  <span v-if="content?.content">
                    {{ content?.content[0]?.value }}
                  </span>
                  <i
                    v-if="content?.content"
                    class="mdi mdi-arrow-right ml-2"
                  ></i>
                </span>
              </md-filled-tonal-button>
              <span v-else v-for="(content, x) in fields.content" :key="x">
                <span
                  v-if="content?.nodeType === 'hyperlink'"
                  @click="openLink(content?.data?.uri)"
                  class="hyper-link"
                >
                  {{ content.content[0]?.value }}
                </span>
                <span v-else>{{ content?.value }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="hot-site-tutorials-wrapper">
          <div
            v-for="(tutorial, x) in getHotSite?.fields?.tutorials?.content"
            :key="x"
          >
            <div
              v-if="tutorial?.nodeType === 'heading-3'"
              class="hot-site-tutorials-title"
            >
              {{ tutorial?.content[0]?.value }}
            </div>
            <div v-if="tutorial?.nodeType === 'paragraph'">
              <div v-for="(items, y) in tutorial?.content" :key="y">
                <div
                  v-if="
                    items?.nodeType === 'hyperlink' &&
                    items?.content[0]?.marks?.length === 0
                  "
                  class="hot-site-tutorials-video"
                >
                  <iframe
                    width="100%"
                    height="100%"
                    :src="items?.data?.uri"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
                <div
                  v-if="
                    items?.nodeType === 'hyperlink' &&
                    items?.content[0]?.marks?.length > 0
                  "
                >
                  <md-filled-tonal-button
                    class="guides-read-more-button"
                    @click="() => {}"
                  >
                    {{ items?.content[0]?.value }}
                    <i class="mdi mdi-arrow-right"></i>
                  </md-filled-tonal-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <img
      class="hot-site-testimonials-image"
      :src="require('@/assets/images/logoColored.png')"
      alt="header logo image"
    />
    <div class="hot-site-thank-you-title">Your Spanish Journey Starts Here</div>
    <div class="row hot-site-thank-you-wrapper">
      <div class="col-lg-2"></div>
      <div class="col-lg-4">
        <img
          class="hot-site-thank-you-images"
          src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/hot-site-thank-you.png?alt=media&token=5e227a8e-3f8e-4fa3-9c67-10e8dc7af073"
          alt=""
        />
      </div>
      <div class="col-lg-4">
        <div class="hot-site-thank-you-left">
          <div class="hot-site-thank-you-subtitle">
            Your free Spanish demo class is officially booked.
          </div>
          <div class="hot-site-thank-you-desc">
            We'll send all the details to your email soon, including how to join
            your class.
          </div>
          <div class="hot-site-thank-you-button">
            <md-filled-tonal-button
              class="learning-hub-outer-download-button"
              @click="openLink('https://comligo.com')"
            >
              Learn More About Comligo
              <i class="mdi mdi-arrow-right"></i>
            </md-filled-tonal-button>
          </div>
        </div>
      </div>
      <div class="col-lg-2"></div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";
import { mapGetters } from "vuex";
import axios from "axios";

SwiperCore.use([Autoplay, Pagination, Navigation]);

export default {
  data() {
    return {
      activeTestimonial: 0,
      images: [],
      imagesPlaceholder: [],
      questionCount: 0,
      activeQuestion: 1,
      questions: [],
      answers: [],
      answerValue: [],
      currentPage: 0,
      calendarLoaded: true,
      tab: 0,
      calendarBooked: false,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    ...mapGetters(["getHotSite"]),
    getProgress() {
      return (this.activeQuestion / this.questionCount) * 100;
    },
    width() {
      const width = window?.screen?.width;
      if (width >= 2000) return "27vw";
      if (width === 1800) return "39vw";
      if (width === 1024) return "66vw";
      const m = (66 - 39) / (1024 - 1800);
      const b = 39 - m * 1800;

      return this.isMobile
        ? this.calendarLoaded
          ? "400px"
          : "1000px"
        : `${Math.round(m * width + b)}vw`;
    },
    isMobile() {
      const width = window?.screen?.width;
      if (width <= 800) return true;
      return false;
    },
    zoom() {
      const width = window?.screen?.width;
      if (width >= 2000) return "100%";
      if (width === 1800) return "75%";
      if (width === 1024) return "42%";
      const m = (42 - 75) / (1024 - 1800);
      const b = 75 - m * 1800;

      return this.isMobile ? "100%" : `${Math.round(m * width + b)}%`;
    },
  },
  mounted() {},
  methods: {
    onSwiper(swiper) {
      this.activeQuestion = swiper.activeIndex + 1;
      this.currentPage = swiper.activeIndex;
    },
    onSlideChange(swiper) {
      this.activeQuestion = swiper.activeIndex + 1;
      this.currentPage = swiper.activeIndex;
    },
    allFields(fields) {
      return [
        ...fields,
        { nodeType: "list-item", content: [{ nodeType: "calendar" }] },
      ];
    },
    answerQuestion(n, options) {
      this.activeQuestion = n + 1;
      this.answerValue[n] = options?.item;
      if (n + 2 === this.questionCount) {
        this.loadCalendly();
      }
      setTimeout(() => {
        if (this.answers[n] !== undefined) {
          document.querySelector(".hot-site-button-next").click();
        }
      }, 100);
    },
    calendlyParams() {
      const utm = ["utm_medium", "utm_term", "utm_campaign", "utm_content"];
      const questions = this.questions.map(
        (q, n) => `&${utm[n]}=${q}: ${this.answerValue[n]}`
      );
      return questions?.join("");
    },
    changeTestimonial(direction, fields) {
      if (direction === "next") {
        if (this.activeTestimonial === fields.length - 1) {
          this.activeTestimonial = 0;
        } else {
          this.activeTestimonial++;
        }
      } else {
        if (this.activeTestimonial === 0) {
          this.activeTestimonial = fields.length - 1;
        } else {
          this.activeTestimonial--;
        }
      }
    },
    getQuestionCount(questions) {
      this.questionCount = questions.length + 1;
      return questions.length;
    },
    loadCalendly() {
      const preloadLink = document.createElement("link");
      preloadLink.rel = "preload";
      preloadLink.as = "script";
      preloadLink.href =
        "https://assets.calendly.com/assets/external/widget.js";
      document.head.appendChild(preloadLink);

      const script = document.createElement("script");
      script.onload = () => {
        window.addEventListener("message", (e) => {
          if (
            e.data.event &&
            e.data.event.indexOf("calendly") === 0 &&
            e.data.event === "calendly.event_type_viewed"
          ) {
            this.calendarLoaded = false;
          }
          if (e.data.event === "calendly.event_scheduled") {
            this.calendarBooked = true;
          }
        });
      };
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      document.head.appendChild(script);
    },
    parseDownloadButton(item) {
      let status = false;
      item.forEach((field) => {
        if (
          field.nodeType === "hyperlink" &&
          (field?.content[0]?.value === "here" ||
            field?.content[0]?.value.toLowerCase().includes("free"))
        ) {
          status = true;
        }
      });
      return status;
    },
    getImageURL(assetId, i) {
      if (assetId) {
        this.imagesPlaceholder[i] = true;
        axios
          .get(
            `https://cdn.contentful.com/spaces/8nqnktj51aoq/assets/${assetId}?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k`
          )
          .then((response) => {
            this.images[i] = `https:${response.data.fields.file.url}`;
          });
      }
    },
    listBullet(item) {
      const content = item?.content[0]?.content;
      let listItem = {
        bold: "",
        text: "",
        link: "",
        image: "",
        name: "",
        title: "",
      };
      if (content?.length === 1) {
        listItem.text = content[0]?.value;
      } else if (content.length === 2) {
        listItem.bold = content[0]?.value;
        listItem.text = content[1]?.value;
      } else {
        listItem.text = content[1]?.content[0]?.value;
        listItem.link = content[1]?.data?.uri;
      }
      item?.content[1]?.content?.forEach((items) => {
        items?.content?.forEach((content) => {
          if (content?.nodeType === "embedded-asset-block") {
            listItem.image = content?.data?.target?.sys?.id;
          } else if (
            content?.nodeType === "paragraph" &&
            content?.content[0]?.marks?.length > 0
          ) {
            listItem.title = content?.content[0]?.value;
          } else if (
            content?.nodeType === "paragraph" &&
            content?.content[0]?.marks?.length === 0
          ) {
            listItem.name = content?.content[0]?.value;
          }
        });
      });
      return listItem;
    },
    openLink(link) {
      window
        .open(
          `${
            link.includes("mail")
              ? ""
              : link.includes("https")
              ? ""
              : "https://"
          }${link}`,
          "_blank"
        )
        .focus();
    },
    parsedQuestions(input) {
      const result = {};
      if (!input || !Array.isArray(input.content)) return result;
      for (const listItem of input.content) {
        if (!Array.isArray(listItem.content)) continue;
        let key = null;
        let values = [];
        for (const inner of listItem.content) {
          if (inner.nodeType === "paragraph") {
            key = inner.content?.[0]?.value;
          }
          if (inner.nodeType === "unordered-list") {
            values = inner.content.map((list) => {
              return list.content?.[0]?.content?.[0]?.value || "";
            });
          }
        }
        if (key) {
          const formattedValues = values.map((v) =>
            typeof v === "string" && v.trim() ? { item: v, value: false } : v
          );
          result[key] = formattedValues;
        }
      }
      return result;
    },
    transformRichTextToTabs(data) {
      const result = [];
      const topListItems = data.content || [];
      for (const listItem of topListItems) {
        const itemContent = listItem.content || [];
        let tabTitle = "";
        const windowItems = [];
        for (const section of itemContent) {
          if (section.nodeType === "paragraph") {
            const textNode = section.content?.[0];
            if (textNode?.nodeType === "text") {
              tabTitle = textNode.value.trim();
            }
          }
          if (section.nodeType === "unordered-list") {
            const listItems = section.content || [];
            for (const listItem of listItems) {
              const paragraph = listItem.content?.[0];
              const text = paragraph?.content?.[0]?.value;
              if (text) {
                windowItems.push(text.trim());
              }
            }
          }
        }
        if (tabTitle && windowItems.length > 0) {
          result.push({
            tab: tabTitle,
            window: windowItems,
          });
        }
      }
      return result;
    },
    setParsedQuestions(input, n) {
      this.questions[n] = input?.content[0]?.value;
    },
  },
};
</script>

<style></style>
